export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_01.d62f8fa0.jpg";